import * as React from "react";

export const PrintIcon = ({
  width = 20,
  height = 18,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
}): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 128 128"
    fill="currentColor"
    width={width}
    height={height}
    {...props}
  >
    <path d="M32 0C23.2 0 16 7.2 16 16v24h16V16h56.7L96 23.3V40h16V23.3c0-4.2-1.7-8.3-4.7-11.3L100 4.7C97 1.7 92.9 0 88.7 0H32zM96 88v8v16H32v-16v-4v-4h64zm16 8h8c4.4 0 8-3.6 8-8v-24c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v24c0 4.4 3.6 8 8 8h8v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V96zM108 62a6 6 0 1 1 0 12 6 6 0 1 1 0-12z" />
  </svg>
);
